module.exports = __webpack_public_path__ + "static/media/lazi.4c4169fb.jpeg";